import { render, staticRenderFns } from "./BudgetSegmentation.vue?vue&type=template&id=74c7c45e&scoped=true"
import script from "./BudgetSegmentation.vue?vue&type=script&lang=js"
export * from "./BudgetSegmentation.vue?vue&type=script&lang=js"
import style0 from "./BudgetSegmentation.vue?vue&type=style&index=0&id=74c7c45e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c7c45e",
  null
  
)

export default component.exports